import React from 'react';
import PropTypes from 'prop-types';

import { HashLink as Link } from 'react-router-hash-link';

import Header from '../header/header';
import Footer from '../footer/footer';
import './page.css';
import './page_mob.css';
import Button from '../button/button';

const response = require('../../data.json');
const data = response.pages;

class Page extends React.Component {
    resolveIndex = (index) => {
        let newIndex = index % data.length;
        if (newIndex < 0) {
            newIndex += data.length;
        }

        return newIndex;
    };

    render() {
        const { pk } = this.props;

        const currentImageIndex = Number.parseInt(pk || 0, 10);
        const path = './page/' + currentImageIndex;

        const slide = data[currentImageIndex];
        let bigImage = slide.bigImage;
        if (window.innerWidth < 900) {
            bigImage = bigImage.replace('.svg', '_mob.png');
        }

        const backgroundColor =
            window.innerWidth < 900 ? slide.backgroundMobile || slide.background : slide.background;

        return (
            <div className="page">
                <Header path={path} style={{ backgroundColor }} />
                <div className="frontpage" style={{ backgroundColor }}>
                    <div className="frontpage__container">
                        <img className="frontpage__image" src={bigImage} />
                        <div className="title">{slide.title}</div>
                        <Button text={slide.name} />
                    </div>
                </div>
                <div className="paint-description">
                    <img alt="" className="star" src="./images/page/star.svg" />
                    <div className="container-left">
                        <div
                            className="name"
                            style={{ backgroundImage: 'url(./images/page/stripes.svg)' }}
                        >
                            {slide.fullName.map((element) => (
                                <div className="line" key={element}>
                                    {element}
                                </div>
                            ))}
                        </div>
                        <div className="description">{slide.description}</div>
                    </div>
                    <div
                        className="container-right"
                        style={{ backgroundImage: `url(${slide.splashImage})` }}
                    />
                </div>
                <div className="shop">
                    <div className="shop__container">
                        <img
                            className="shop__anton"
                            sizes="(max-width: 900px) 519px, 1280px"
                            src="./images/page/anton.svg"
                            srcSet="./images/page/anton.svg 519w, ./images/page/shop.svg"
                        />
                        <div className="text-container">
                            <div className="title">Футболка и сумка с репродукцией</div>
                            <div className="text">
                                Покупайте сумки и футболки с репродукциями картин через
                                интернет-магазин Ламода. Вся полученная прибыль пойдет в помощь
                                подопечным фонда.
                                <br />
                                <br />
                                Переходите на сайт и покупайте футболку или сумку с репродукцией
                                картины «Движение в пространстве» М.В. Матюшина. Рисунок подопечного
                                фонда Николая Толоконникова.
                            </div>
                            <img alt="t-shirt" className="tshirt" src="./images/page/tshirt.png" />
                            <Button
                                href="https://www.lamoda.ru/b/30712/brand-anton-tut-ryadom//"
                                rel="noopener noreferrer"
                                target="_blank"
                                text="перейти в магазин"
                            />
                        </div>
                    </div>
                </div>
                <div className="presents">
                    <div
                        className="emoji"
                        style={{ backgroundImage: 'url(./images/page/emoji.svg)' }}
                    />
                    <div className="title">Подарки в Одноклассниках</div>
                    <div className="text">
                        подари подарок своим друзьям и близким с репродукцией этой картины
                    </div>
                    <a
                        href="https://ok.ru/gifts/charity"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <img
                            className="presents__image"
                            sizes="(max-width: 900px) 640px, 1280px"
                            src="./images/page/mac_mob.png"
                            srcSet="./images/page/mac_mob.png 640w, ./images/page/mac.svg"
                        />
                    </a>
                </div>
                <Slider
                    currentSlide={currentImageIndex}
                    nextSlide={this.resolveIndex(currentImageIndex + 1)}
                    prevSlide={this.resolveIndex(currentImageIndex - 1)}
                />
                <Footer />
            </div>
        );
    }
}

Page.propTypes = {
    pk: PropTypes.number
};

const Slider = ({ prevSlide, nextSlide }) => {
    const left = data[prevSlide];
    const right = data[nextSlide];
    return (
        <div className="page-slider">
            <div className="prev-slide" style={{ backgroundColor: left.background }}>
                <div className="container">
                    <div className="text">предыдущая репродукция</div>
                    <div className="title">{left.title}</div>
                    <div className="name">{left.name}</div>
                    <Link
                        className="icon"
                        style={{ backgroundImage: `url(./images/page/btn-prev.svg)` }}
                        to={'/page/' + prevSlide}
                    />
                    <div className="image" style={{ backgroundImage: `url(${left.smallImage})` }} />
                </div>
            </div>
            <div className="next-slide" style={{ backgroundColor: right.background }}>
                <div className="container">
                    <div className="text">следующая репродукция</div>
                    <div className="title">{right.title}</div>
                    <div className="name">{right.name}</div>
                    <Link
                        className="icon"
                        style={{ backgroundImage: `url(./images/page/btn-next.svg)` }}
                        to={'/page/' + nextSlide}
                    />
                    <div
                        className="image"
                        style={{ backgroundImage: `url(${right.smallImage})` }}
                    />
                </div>
            </div>
        </div>
    );
};

Slider.propTypes = {
    prevSlide: PropTypes.number,
    nextSlide: PropTypes.number
};

export default Page;
